


import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
    myStyle?: string;

}

function Folder({ color, myStyle }: Props): ReactElement {

    return (
        <svg
            className={myStyle ? myStyle : ""}
            width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.9987 8.33398L10.832 8.33398" stroke="#155a9e" strokeLinecap="round" />
            <path d="M8.33203 2.5H13.7487C14.1357 2.5 14.3292 2.5 14.4917 2.52139C15.6135 2.66908 16.4963 3.55185 16.644 4.67368C16.6654 4.83614 16.6654 5.02965 16.6654 5.41667" stroke="#155a9e" />
            <path d="M1.66797 5.7908C1.66797 5.05536 1.66797 4.68764 1.72576 4.38134C1.98017 3.03294 3.03489 1.97822 4.38329 1.72381C4.68959 1.66602 5.05732 1.66602 5.79276 1.66602C6.11499 1.66602 6.2761 1.66602 6.43094 1.6805C7.09851 1.74292 7.73174 2.00521 8.24792 2.43311C8.36765 2.53236 8.48157 2.64629 8.70943 2.87414L9.16797 3.33268C9.84779 4.0125 10.1877 4.35241 10.5947 4.57887C10.8183 4.70327 11.0555 4.80152 11.3016 4.87166C11.7495 4.99935 12.2303 4.99935 13.1917 4.99935H13.503C15.6967 4.99935 16.7935 4.99935 17.5064 5.64057C17.572 5.69955 17.6344 5.76196 17.6934 5.82754C18.3346 6.54048 18.3346 7.6373 18.3346 9.83094V11.666C18.3346 14.8087 18.3346 16.3801 17.3583 17.3564C16.382 18.3327 14.8107 18.3327 11.668 18.3327H8.33463C5.19194 18.3327 3.62059 18.3327 2.64428 17.3564C1.66797 16.3801 1.66797 14.8087 1.66797 11.666V5.7908Z" stroke="#424242" />
        </svg>
    );
}

export default Folder;